import React, { useRef, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@/components/material-ui-kit/components/CustomButtons/Button';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import CollectionsIcon from '@material-ui/icons/Collections';
import styles from 'styles/jss/original/components/menus/detailAction';
import { LightgalleryProvider, LightgalleryItem } from 'react-lightgallery';
import { IMenu } from '@/@types/generated/contentful';
import { Asset } from 'contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  menu: IMenu;
};

const DetailAction: React.FC<ComponentProps> = ({ menu }) => {
  const { galleryImage, galleryText } = menu.fields;
  const galleryItemRef = useRef<React.ReactNode>(null);
  const classes = useStyles();
  const handleClick = useCallback(() => {
    if (!galleryItemRef) return;

    // @ts-expect-error
    galleryItemRef.current.open();
  }, []);

  if (!galleryImage || galleryImage.length === 0) return null;
  const galleryList = galleryImage
    .map((item) => {
      return { image: item.fields };
    })
    .map((item, index) => (galleryText ? Object.assign(item, { text: galleryText[index] }) : item));
  const PhotoItem = ({
    item,
    index,
    group
  }: {
    item: { image: Asset['fields']; text?: string };
    index: number;
    group: string;
  }) => (
    <div>
      {index === 0 ? (
        <LightgalleryItem
          group={group}
          src={item.image.file.url}
          subHtml={item.text}
          ref={galleryItemRef}
        >
          <img src={item.image.file.url} className={classes.displayNone} />
        </LightgalleryItem>
      ) : (
        <LightgalleryItem group={group} src={item.image.file.url} subHtml={item.text}>
          <img src={item.image.file.url} className={classes.displayNone} />
        </LightgalleryItem>
      )}
    </div>
  );
  return (
    <div className={classes.box}>
      <LightgalleryProvider plugins={[]}>
        {/* @ts-expect-error */}
        <GridContainer justify='center' style={{ display: 'none' }}>
          {galleryList.map((item, index) => {
            return (
              // @ts-expect-error
              <GridItem xs={6} sm={4} md={2} key={item.text}>
                <PhotoItem item={item} index={index} group='menuGallery' />
              </GridItem>
            );
          })}
        </GridContainer>
      </LightgalleryProvider>
      {/* @ts-expect-error */}
      <Button color='danger' round onClick={handleClick}>
        <CollectionsIcon /> &nbsp; ギャラリーを見る
      </Button>
    </div>
  );
};

export default DetailAction;
